export const queryBonusUserDetails = `
query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    active
    title
  }
}
`;
